<script>
import { mapGetters } from 'vuex';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  emits: ['update', 'close', 'assign'],
  data() {
    return {
      query: '',
      selectedLabels: [],
    };
  },
  computed: {
    ...mapGetters({ labels: 'labels/getLabels' }),
    filteredLabels() {
      return this.labels.filter(label =>
        label.title.toLowerCase().includes(this.query.toLowerCase())
      );
    },
  },
  methods: {
    isLabelSelected(label) {
      return this.selectedLabels.includes(label);
    },
    assignLabels(key) {
      this.$emit('update', key);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div v-on-clickaway="onClose" class="labels-container">
    <div class="triangle">
      <svg height="12" viewBox="0 0 24 12" width="24">
        <path d="M20 12l-8-8-12 12" fill-rule="evenodd" stroke-width="1px" />
      </svg>
    </div>
    <div class="flex items-center justify-between header">
      <span>{{ $t('BULK_ACTION.LABELS.ASSIGN_LABELS') }}</span>
      <NextButton ghost xs slate icon="i-lucide-x" @click="onClose" />
    </div>
    <div class="labels-list">
      <header class="labels-list__header">
        <div
          class="flex items-center justify-between h-8 gap-2 label-list-search"
        >
          <fluent-icon icon="search" class="search-icon" size="16" />
          <input
            v-model="query"
            type="search"
            :placeholder="$t('BULK_ACTION.SEARCH_INPUT_PLACEHOLDER')"
            class="reset-base !outline-0 !text-sm label--search_input"
          />
        </div>
      </header>
      <ul class="labels-list__body">
        <li
          v-for="label in filteredLabels"
          :key="label.id"
          class="label__list-item"
        >
          <label
            class="item"
            :class="{ 'label-selected': isLabelSelected(label.title) }"
          >
            <input
              v-model="selectedLabels"
              type="checkbox"
              :value="label.title"
              class="label-checkbox"
            />
            <span
              class="overflow-hidden label-title whitespace-nowrap text-ellipsis"
            >
              {{ label.title }}
            </span>
            <span
              class="label-pill"
              :style="{ backgroundColor: label.color }"
            />
          </label>
        </li>
      </ul>
      <footer class="labels-list__footer">
        <NextButton
          sm
          type="submit"
          :label="$t('BULK_ACTION.LABELS.ASSIGN_SELECTED_LABELS')"
          :disabled="!selectedLabels.length"
          @click="$emit('assign', selectedLabels)"
        />
      </footer>
    </div>
  </div>
</template>

<style scoped lang="scss">
.labels-list {

  .labels-list__header {
  }

  .labels-list__body {
  }

  .labels-list__footer {

    button {

      .button__content {
      }
    }
  }
}

.label-list-search {

  .search-icon {
  }

  .label--search_input {
  }
}

.labels-container {

  .header {

    span {
    }
  }

  .container {

    .label__list-container {
    }
  }

  .triangle {
    right: var(--triangle-position);

    svg path {
    }
  }
}

ul {
}

.labels-placeholder {
}

.label__list-item {

  .item {

    &.label-selected {
    }

    span {
    }

    .label-checkbox {
    }

    .label-title {
    }

    .label-pill {
    }
  }
}

.search-container {
}

.actions-container {

  button {
  }
}
</style>
